import React, { useEffect, useState } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';
import { useAuth } from 'context/authContext';
import { verifyInvitation } from 'api/api';
import { ResetPasswordNewManager } from 'components';
import { ROLE_TYPES } from 'api/constants';
import Skates from 'assets/images/skates.png';

export const VerifyInvitation = () => {
  const [userEmail, setUserEmail] = useState('');
  const location = useLocation();
  const navigate = useNavigate();
  const { auth, role } = useAuth();
  const pathParts = location.pathname.split('/').filter(Boolean);
  const code = pathParts.pop();

  useEffect(() => {
    if (auth && role === ROLE_TYPES.slh_manager) {
      navigate('/dashboard', { replace: true });
    }
  }, [auth, role, navigate]);

  useEffect(() => {
    if (auth && role === ROLE_TYPES.slh_manager) return;
    if (!code) return;

    verifyInvitation(code)
      .then((response) => {
        setUserEmail(response.email);
      })
      .catch(() => {
        navigate('/', { replace: true });
      });
  }, [code, auth, role, navigate]);

  return userEmail ? (
    <div className="flex relative justify-end h-full overflow-y-auto overflow-x-hidden bg-orange min-h-screen">
      <div className="absolute z-10 top-0 bottom-0 left-[31%] -translate-x-1/2">
        <ResetPasswordNewManager
          domain={ROLE_TYPES.slh_manager}
          userEmail={userEmail}
          verifiedCode={code}
        />
      </div>
      <div className="w-[69%] min-h-[52rem] relative">
        <img
          className="absolute left-0 bottom-0 right-0 w-full h-full object-cover"
          src={Skates}
          alt="hero"
        />
      </div>
    </div>
  ) : null;
};
